import * as React from 'react';
import * as ReactModal from 'react-modal';
import styles from './Modal.st.css';
import { ModalParentNodeRefConsumer } from '../../../contexts/ModalParentNodeRefContext';

export interface ModalProps extends ReactModal.Props {
  isOpen: boolean;
  onRequestClose(): void;
}

class Modal extends React.Component<ModalProps> {
  render() {
    const { onRequestClose, ...modalProps } = this.props;

    return (
      <ModalParentNodeRefConsumer>
        {appNode => {
          if (appNode) {
            modalProps.parentSelector = () => appNode;
          }
          return (
            <ReactModal
              className={styles.modal}
              overlayClassName={styles.overlay}
              ariaHideApp={false}
              onRequestClose={onRequestClose}
              {...modalProps}
            >
              <div
                className={styles.closeButtonWrapper}
                onClick={onRequestClose}
              >
                x
              </div>
              {this.props.children}
            </ReactModal>
          );
        }}
      </ModalParentNodeRefConsumer>
    );
  }
}

export default Modal;
